// src/menu-items/banking.ts
import { Bank } from 'iconoir-react';
import type { NavItemType } from 'types/menu';

const banking: NavItemType = {
  id: 'banking',
  title: 'Banking',
  type: 'group',
  children: [
    {
      id: 'sepa-payment',
      title: 'SEPA Payment',
      type: 'item',
      url: '/banking/sepa-payment',
      icon: Bank,
    },
  ],
};

export default banking;
